import { render, staticRenderFns } from "./InstagramAuth.vue?vue&type=template&id=d2ade25e&"
import script from "./InstagramAuth.vue?vue&type=script&lang=js&"
export * from "./InstagramAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports